import React, { memo } from "react";
import { useStore } from "src/store";
import { Icon } from "src/primitives";
import api, { useAsync } from "src/api";
import { useOnce } from "src/utils";
import styles from "./style.css";

const BingTrendingTerms = memo(props => {
  const store = useStore("config");
  const { clientid: clientId, brand: affiliateId } = store("config");
  const { bingTrendingTermsQuantity, bingTrendingStyles = "1", bingTrendingTracingID, bingTrendingPostBackURL, asDropdown = false, formCode, clientSideEnabledSearchBar = false, clientSideEnabled = false, searchBarBingTrendingTerms, bingTrendingSearchType = "bingDistribution", searchBarBingTrendingSearchType = "bingDistribution" } = props;
  const getBingTrendingTerms = useAsync(api.getBingTrendingTerms, { cache: true });
  const getBingTrendingTermsClient = useAsync(api.getBingTrendingTermsClient, { cache: true, params: props });
  const trendingUrlParams = {
    clientId,
    affiliateId,
    subAffiliateId: bingTrendingTracingID,
    limit: bingTrendingTermsQuantity,
    clientSideEnabledSearchBar,
    clientSideEnabled,
    formCode,
    searchBarBingTrendingTerms,
    bingTrendingSearchType,
    searchBarBingTrendingSearchType
    //referrer: encodeURIComponent("https://klint.staging.airfind.com")
  };
  let trendingTermsResult;
  if (clientSideEnabledSearchBar || clientSideEnabled) {
    trendingTermsResult = getBingTrendingTermsClient(trendingUrlParams);
  } else {
    trendingTermsResult = getBingTrendingTerms(trendingUrlParams);
  }


  const { loading, data } = trendingTermsResult;
  let { trendingTerms = [] } = data;
  if (clientSideEnabledSearchBar || clientSideEnabled) {
    trendingTerms = data.impressions && data.impressions[0] && data.impressions[0].queries ? data.impressions[0].queries : []
  }
  //{"impressions":[{"queries":[{"query":"Lemur Missing San Francisco Zoo","url":"https://www.bing.com/search/?q=Lem 
  const style = parseInt(bingTrendingStyles);
  
  if(style === 11 && trendingTerms.length) {
    const privacyItem = {query: "Trending Topics from Bing (privacy)", url: "https://privacy.microsoft.com/en-US/privacystatement"}
    trendingTerms= [...trendingTerms, privacyItem]
  } 
  
  let styleIcon = null;
  switch (style) {
    case 1:
    case 2:
    case 6:
    case 7:
      styleIcon = <Icon class={styles.icon} name="search" />;
      break;
    case 3:
      styleIcon = <Icon class={styles.icon} name="call_made" />;
      break;
    case 4:
      styleIcon = <Icon class={styles.icon} name="arrow_right_alt" />;
      break;
    case 8:
    case 9:
    case 10:
      styleIcon = <Icon class={styles.icon} name="play_arrow" />;
      break;
    case 11:
      styleIcon = <Icon class={styles.icon} name="search" />;
      break;
    default:
      break;
  }

  const renderedTrendingTerms = trendingTerms.map((item, index) => {
    return style === 6 ?
      <a key={index} href={item.url} onClick={() => fireClick()}>
        {styleIcon}
        <label>{item.query}</label>
      </a>
      : style === 8 ?
        <a key={index} href={item.url} onClick={() => fireClick()}>
          <div></div>
          <label>{index + 1}    {item.query}</label>
          {styleIcon}
        </a>
        :
        <a key={index} href={item.url} onClick={() => fireClick()}>
          <label>{item.query}</label>
          {styleIcon}
        </a>;
  });

  let dropdownCls = asDropdown ? ' ' + styles.dropdown : '';
  const fireAdReq = useOnce(() => window.afAdRequest && window.afAdRequest('adRequest', formCode, 'bingTrends'));
  const fireImpre = useOnce(() => window.afAdRequest && window.afAdRequest('impression', formCode, 'bingTrends'));
  const fireClick = () => {
    if (window.afAdRequest)
      window.afAdRequest('click', formCode, 'bingTrends');
    if (bingTrendingPostBackURL)
      fetch(bingTrendingPostBackURL);
  };
  fireAdReq();
  if (!loading && trendingTerms.length > 0) fireImpre();

  return loading ? (
    <Placeholder dropdownCls={dropdownCls} />
  ) : trendingTerms.length > 0 ? (
    <div class={styles.container + " " + styles['trendingStyle_' + style] + dropdownCls}>
      {!asDropdown ? <div class={styles.header}>{style === 11 ? "TRENDING TOPICS" : "Recommended Searches"}</div> : null}
      <div class={styles.content} style={style === 10 ? "display:grid; grid-template-columns:repeat(2,1fr); grid-gap: 0.5em;" : ""}>{renderedTrendingTerms}</div>
     {style != 11 && <div class={styles.footer}>
        <span>Recommended Searches from Bing (
          <a href="https://privacy.microsoft.com/en-US/privacystatement">privacy</a>
          )</span>
      </div>}
    </div>
  ) : null;
});

const Placeholder = (({ dropdownCls }) => (
  <div class={styles.container + " " + styles.placeholder + dropdownCls}>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
));
export default BingTrendingTerms;
